import { render, staticRenderFns } from "./UniPromotionTask.vue?vue&type=template&id=0fbe1864&scoped=true"
import script from "./UniPromotionTask.vue?vue&type=script&lang=js"
export * from "./UniPromotionTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbe1864",
  null
  
)

export default component.exports